<script setup lang="ts">
    import { CircleAlert } from 'lucide-vue-next';
    import { HoverCardContent, HoverCardPortal, HoverCardRoot, HoverCardTrigger } from 'reka-ui';
    import { useI18n } from 'vue-i18n';
    import { formatDate, formatCurrency } from '@/utils/helpers';

    const props = defineProps<{
        unnotedSalary: any;
    }>();

    const { t } = useI18n();
</script>

<template>
    <HoverCardRoot
        :close-delay="0"
        :open-delay="0"
    >
        <HoverCardTrigger>
            <CircleAlert class="text-warning size-4" />
        </HoverCardTrigger>
        <HoverCardPortal>
            <HoverCardContent
                class="animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 flex flex-col gap-1 rounded-xl border bg-white p-4 shadow-sm data-[state=open]:transition-all"
                :side-offset="5"
            >
                <div class="flex items-center gap-2">
                    <CircleAlert class="text-secondary size-4" />
                    <span class="text-xs">
                        {{
                            t('employee.changes.past_salary', {
                                amount: formatCurrency(unnotedSalary.amount),
                                date: formatDate(unnotedSalary.starts_at),
                            })
                        }}
                    </span>
                </div>
            </HoverCardContent>
        </HoverCardPortal>
    </HoverCardRoot>
</template>
